import { Dialog, DialogContent } from '@/components/ui/dialog';
import { RootState } from '@/redux/store/store';
import { useSelector } from 'react-redux';
import ManualSolicitationSummary, {
	FormData,
} from '@/components/ManualSolicitation/ManualSolicitationSummary/ManualSolicitationSummary';
import SecondaryButton from '@/components/ui/shared/Button/SecondaryButton/SecondaryButton';
import PrimaryButton from '@/components/ui/shared/Button/PrimaryButton/PrimaryButton';
import { useAppDispatch } from '@/lib/hooks/hooks';
import { ErrorHandle, handleResponse } from '@/lib/functions/funcUtils';
import { useNavigate } from 'react-router';
import { closeDialog } from '@/redux/slices/pageSlice';
import {
	ManualSolicitation,
	ManualSolicitationPayload,
} from '@/lib/types/apiTypes';
import { createDocument } from '@/lib/functions/apiCalls';
import { setManualSolicitation } from '@/redux/slices/manualSolicitationSlice';
import DialogLoader from '@/components/Loader/DialogLoader/DailogLoader';
import { useState } from 'react';

const ManualSolicitationDialog = () => {
	const dispatch = useAppDispatch();
	const isOpen = useSelector(
		(root: RootState) => root.page.dialog?.type === 'manualSolicitation'
	);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const navigate = useNavigate();

	const formatPayload = (formData: FormData): ManualSolicitationPayload => {
		return {
			name: formData.title,
			type: 'rfpDocument',
			isSolicited: false,
			metaData: {
				funding: formData.fundingAmount || null,
				deadline: formData.deadline || null,
				agency: formData.agency || null,
			},
			summary: formData.summary,
		};
	};

	const onSubmit = async (formData: FormData) => {
		try {
			setIsLoading(true);
			const payload = formatPayload(formData);
			const response = await createDocument(payload);
			handleResponse(response);
			const data = response.data as ManualSolicitation;
			dispatch(setManualSolicitation(data));
			clearChange();
			navigate('solicitation/manual');
			setIsLoading(false);
		} catch (error: unknown) {
			ErrorHandle(dispatch, error);
			setIsLoading(false);
		}
	};

	const clearChange = () => {
		dispatch(closeDialog());
	};

	const controlLayout = () => {
		return (
			<div className="flex justify-end gap-3 mt-auto">
				<SecondaryButton onClick={clearChange} type="reset">
					Cancel
				</SecondaryButton>
				<PrimaryButton className="self-center w-fit" type="submit">
					Continue
				</PrimaryButton>
			</div>
		);
	};
	return (
		<Dialog open={isOpen}>
			<DialogContent className="max-w-[950px] shadow-none bg-white">
				<ManualSolicitationSummary
					type="dialog"
					controlLayout={controlLayout()}
					onSubmit={onSubmit}
				/>
				<DialogLoader isLoading={isLoading} />
			</DialogContent>
		</Dialog>
	);
};

export default ManualSolicitationDialog;
